import { AppState } from './app.model';

const appDefault: AppState = {
  token: null,
};

export default appDefault;
